export const getPublicKey = (user, contractFolder) => {
  let publicKeyToUse = user?.publicKey
/*   if (contractFolder.sharedTo) {
    publicKeyToUse = contractFolder.owner.publicKey
  } */

  return publicKeyToUse
}
